import { gql } from "@apollo/client";

export const GET_DASHBOARD = gql`
query Dashboard($where: dashboardWhereInput!) {
  dashboard(where: $where) {
    totalOrder
    totalPrice
    totalStock
    goodProduct {
      amount
      name
    }
    weeks {
      amount
      name
      price
      priceBaht
      priceUsd
      originPrice
      originPriceBaht
      originPriceUsd
    }
    months {
      amount
      name
      price
      priceBaht
      priceUsd
      originPrice
      originPriceBaht
      originPriceUsd
    }
    years {
      name
      amount
      price
      priceBaht
      priceUsd
      originPrice
      originPriceBaht
      originPriceUsd
    }
  }
}
`;

export const GET_NEW_DASHBOARD = gql`
query GetDashboard($where: DashboardRequest!) {
  getDashboard(where: $where) {
    tag
    totalOrder
    totalPrice
    totalStock
    goodProduct {
      name
      amount
      price
      totalPrice
    }
    totalFilter {
      name
      amount
      price
      priceBaht
      priceUsd
      originPrice
      originPriceBaht
      originPriceUsd
    }
    balance {
      balance {
        price
        priceBaht
        priceUsd
      }
      cost {
        price
        priceBaht
        priceUsd
      }
      profit {
        price
        priceBaht
        priceUsd
      }
      amount {
        amount
        amountBaht
        amountUsd
      }
      sale {
        price
        priceBaht
        priceUsd
      }
    }
    balanceCurrentDate {
      balance {
        price
        priceBaht
        priceUsd
      }
      cost {
        price
        priceBaht
        priceUsd
      }
      profit {
        price
        priceBaht
        priceUsd
      }
      amount {
        amount
        amountBaht
        amountUsd
      }
      sale {
        price
        priceBaht
        priceUsd
      }
    }
  }
}
`;